
export function koComponent(name, componentClass) {

    return (customParam) => {
        //console.log('before register', name);
        if (!ko.components.isRegistered(name)) {
            //console.log('registering', name);
            ko.components.register(name, {
                viewModel: {
                    createViewModel: function (params, componentInfo) {
                        // - 'params' is an object whose key/value pairs are the parameters
                        //   passed from the component binding or custom element
                        // - 'componentInfo.element' is the element the component is being
                        //   injected into. When createViewModel is called, the template has
                        //   already been injected into this element, but isn't yet bound.
                        // - 'componentInfo.templateNodes' is an array containing any DOM
                        //   nodes that have been supplied to the component. See below.
                        //console.log('CREATING', params);
                        return new componentClass(params, customParam);
                    }
                },
                template: { element: name + 'Template' }
            });
        }

        return name;
    }
}

export function subscribeModelChange(model, callback) {
    const disposables = [];
    for (const key of Object.keys(model)) {
        if (ko.isSubscribable(model[key])) {
            disposables.push(model[key].subscribe(callback));
        }
    }
    return () => {
        disposables.forEach(d => d.dispose());
    }
}